import React, { useEffect, useState, useMemo } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import "./ParticlesBackground.css";

const ParticlesBackground = ({ isDarkMode }) => {
  const [isMobile, setIsMobile] = useState(false);

  const particlesInit = async (main) => {
    await loadFull(main);
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    setIsMobile(mediaQuery.matches);

    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  // IMPORTANT: Memoize options so they don't recreate each slide change
  const particleOptions = useMemo(() => ({
    fullScreen: { enable: false },
    detectRetina: true,
    fpsLimit: 60,

    particles: {
      number: {
        value: isMobile ? 28 : 55,
        density: {
          enable: true,
          area: 900,
        },
      },

      color: {
        value: isDarkMode ? "#303be4" : "#4c6fff",
      },

      opacity: {
        value: isDarkMode ? 0.7 : 0.5,
        animation: {
          enable: true,
          speed: 0.4,
          minimumValue: 0.3,
          sync: false,
        },
      },

      size: {
        value: { min: 1, max: isMobile ? 2.5 : 3.5 },
      },

      move: {
        enable: true,
        speed: 0.45,
        direction: "none",
        random: false,
        straight: false,
        outModes: {
          default: "bounce",
        },
      },

      links: {
        enable: true,
        distance: isMobile ? 95 : 140,
        color: isDarkMode ? "#303be4" : "#4c6fff",
        opacity: isDarkMode ? 0.35 : 0.18,
        width: 1,
      },
    },

    interactivity: {
      events: {
        onHover: {
          enable: !isMobile,
          mode: "grab",
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 150,
          links: {
            opacity: 0.4,
          },
        },
      },
    },
  }), [isDarkMode, isMobile]);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={particleOptions}
    />
  );
};

// Prevent re-render unless props actually change
export default React.memo(ParticlesBackground);
